/* @generated from adl module ferovinum.sourcecontracts.ledgerreconciliationmismatch */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.ledger_reconciliation_mismatch` contract.
 */
export interface LedgerReconciliationMismatchSource {
  id: common_strings.StringNE;
  runId: common_strings.StringNE;
  contractLegId: string;
  dealLegId: ferovinum_app_db.DealLegId;
  position: string;
  posted: common.BigDecimal;
  expected: common.BigDecimal;
  independent: (common.BigDecimal|null);
  tolerance: common.BigDecimal;
}

export function makeLedgerReconciliationMismatchSource(
  input: {
    id: common_strings.StringNE,
    runId: common_strings.StringNE,
    contractLegId: string,
    dealLegId: ferovinum_app_db.DealLegId,
    position: string,
    posted: common.BigDecimal,
    expected: common.BigDecimal,
    independent: (common.BigDecimal|null),
    tolerance: common.BigDecimal,
  }
): LedgerReconciliationMismatchSource {
  return {
    id: input.id,
    runId: input.runId,
    contractLegId: input.contractLegId,
    dealLegId: input.dealLegId,
    position: input.position,
    posted: input.posted,
    expected: input.expected,
    independent: input.independent,
    tolerance: input.tolerance,
  };
}

const LedgerReconciliationMismatchSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.ledgerreconciliationmismatch","decl":{"annotations":[{"value":{"modelName":"source__app_db.ledger_reconciliation_mismatch","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.ledger_reconciliation_mismatch` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"runId","default":{"kind":"nothing"},"name":"runId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contractLegId","default":{"kind":"nothing"},"name":"contractLegId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"dealLegId","default":{"kind":"nothing"},"name":"dealLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"position","default":{"kind":"nothing"},"name":"position","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"posted","default":{"kind":"nothing"},"name":"posted","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"expected","default":{"kind":"nothing"},"name":"expected","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"independent","default":{"kind":"nothing"},"name":"independent","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"tolerance","default":{"kind":"nothing"},"name":"tolerance","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"LedgerReconciliationMismatchSource","version":{"kind":"nothing"}}};

export const snLedgerReconciliationMismatchSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.ledgerreconciliationmismatch", name:"LedgerReconciliationMismatchSource"};

export function texprLedgerReconciliationMismatchSource(): ADL.ATypeExpr<LedgerReconciliationMismatchSource> {
  return {value : {typeRef : {kind: "reference", value : snLedgerReconciliationMismatchSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.ledgerreconciliationmismatch.LedgerReconciliationMismatchSource" : LedgerReconciliationMismatchSource_AST
};
